<template>
  <div class="permission-empty">
    <i class="el-icon-lock" />
    <h2>暂无访问权限</h2>
    <p>当前账号尚未获得此页面的权限，请联系主账号管理员分配角色。</p>
    <el-button type="primary" :loading="loading" @click="refresh">刷新权限</el-button>
  </div>
</template>
<script>
import { getCurrentUser } from '@/utils/auth'
import { firstAuthorizedPath } from '@/utils/permissionNavigation'
export default {
  name: 'PermissionForbiddenPage',
  data() { return { loading: false } },
  methods: {
    async refresh() {
      this.loading = true
      try {
        const user = await getCurrentUser(true)
        const target = firstAuthorizedPath(user)
        if (target === '/forbidden') this.$message.info('暂未分配可访问菜单')
        else await this.$router.replace(target)
      } catch (error) { this.$message.error(error.msg || '刷新权限失败') } finally { this.loading = false }
    }
  }
}
</script>
<style scoped>
.permission-empty { padding: 120px 24px; text-align: center; background: #fff; border-radius: 12px; }
.permission-empty > i { font-size: 54px; color: #1677ff; }
.permission-empty h2 { color: #303133; font-weight: 500; }
.permission-empty p { color: #909399; margin-bottom: 28px; }
</style>
